import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { SOLUTIONS } from "@/data/solutions";

export default function Solutions() {
  return (
    <section id="solutions" className="bg-navy grain relative py-24 lg:py-32">
      <div className="relative z-10 max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="eyebrow text-gold mb-4 flex items-center gap-3">
            <span className="inline-block w-8 h-px bg-gold" /> Solutions By Need
          </p>
          <h2 className="font-heading font-extrabold tracking-tighter text-warm-white text-[clamp(2rem,4.5vw,3.4rem)] leading-[1]">
            Coverage built around your situation.
          </h2>
          <p className="mt-4 text-light-slate leading-relaxed">
            The right strategy depends on who you're protecting. Explore the approach tailored to you.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-4">
          {SOLUTIONS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.key}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
              >
                <Link
                  to={`/solutions/${s.key}`}
                  data-testid={`solution-card-${s.key}`}
                  className="group flex flex-col h-full rounded-2xl border border-white/10 bg-white/[0.03] p-7 transition-all hover:bg-white/[0.06] hover:border-gold/40"
                >
                  <span className="grid place-items-center w-13 h-13 w-[52px] h-[52px] rounded-xl bg-gold/15 text-gold mb-6">
                    <Icon weight="duotone" size={28} />
                  </span>
                  <p className="eyebrow text-gold/80 mb-2">{s.audience}</p>
                  <h3 className="font-heading font-bold text-warm-white text-2xl leading-tight">{s.title}</h3>
                  <p className="mt-3 text-light-slate text-sm leading-relaxed flex-1">{s.tagline}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-warm-white font-semibold text-sm group-hover:text-gold transition-colors">
                    Explore this solution
                    <ArrowUpRight weight="bold" size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
